import { render, staticRenderFns } from "./PickupOrders.vue?vue&type=template&id=a344464c"
import script from "./PickupOrders.vue?vue&type=script&lang=js"
export * from "./PickupOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports